export enum EmployeeSortType {
  Id,
  FirstName,
  LastName,
  NationalIdentity,
  CellphoneNumber,
  Email,
  Username,
  Gender,
  IsActive,
  BirthDate,
  IsDeleted,
  PersonalPicture
}
